<section class="healthcare-banner instool aashi">
    <div class="container">
        <div class="row zmc">
            <div class="col-lg-9 col-md-9 col-sm-12 col-12 service-heading">
                <div class="headtext">
                    <h1>Flaunt a perfect look with Marc Fisher’s footwear collection.

                    </h1><br>
<title>Flaunt a perfect look with Marc Fisher’s footwear collection. </title>


                    <!-- <p >We design and build superior digital products, delegating seamless user experiences across all modern platforms and devices and helping brands to expand their business globally. -->
                    <!-- </p><a  routerLink="/getaquote.html"
                                            class="ar_contect-industries-header"><span
                                                    >Request a Free
                                                    Quote</span></a> -->
                </div>
            </div>
        </div>
    </div>

</section>

<div class="casestudy-details pt-120 pb-120">
    <div class="container logo-box">
        <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/marc-fisher-logo.jpg?alt=media&token=ba2fb7b3-45cd-40db-bdd4-715c06f14c04" alt="image"
                        class="ilast-logo">
        
    </div>
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-8">
                <div class="case-details-single">
                    <h2>Marc Fisher
                    </h2>
                    <p>
                        A lifelong passion for Glamorous Shoes. Marc Fisher is an e-commerce website where women and men can purchase their favorite footwear. With trending and fabulous styles of footwear, customers can easily make a purchase with the best combination of footwear. Marc Fisher is a USA-based footwear brand owned by Marc Fisher.  
                    </p>
                    <p>
                    </p>
                    <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/photo-1535659513767-f1a7b068ebc1.webp?alt=media&token=10a1f525-6d99-4b1e-a543-191be8664714" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-4">
                <div class="case-sidebar-area">
                    <ul class="case-info-list">
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Team Size :</span>
                            <h5> 5 Members</h5>
                            <h5>
                                Developers | Designers | BA | Project Manager | Quality Analyst
                            </h5>
                        </li>
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Industry :</span>
                            <h5> E-commerce & Retail
                            </h5>
                        </li>
                        <li><span><img src="../../../assets/images/sidebar-arrow.svg" alt="image">Duration :</span>
                            <h5>   35 Days

                            </h5>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 case-details-single">
            

                <div class="area">
                    <h4> Who is the Client?</h4>
                <p class="para">Marc Fisher is a footwear brand known for selling high-quality men's and women's footwear. They had to have a website for their brand to reach out to their targeted market. Marc Fisher is a total footwear brand targeting men and women both.  </p>
            <p class="para">
                The Marc Fisher footwear collection reflects the modern-age style. The look is up to the mark which looks clean and effortless and its global style is defined as “The New Casual Luxe”. Marc Fisher had a passion for shoes for a very long time. There is an appreciation for design as it is chic, timeless, and simple yet attractive to the customers.             </p>     
            </div>
                <div class="area">
                    <h4> Purpose of the Client
                    </h4>
                    <p class="para"> The client wanted to have a new website for the Marc Fisher brand. Their footwear collection embodies timeless style. They wanted to showcase the footwear via their website around the globe, mainly in the USA.  </p>

                    <p class="para"> The client wanted to have a website that can be built using Shopify where users can interactively scroll through the categories. Marc Fisher is a renowned footwear brand working closely with ongoing trends and fashion. </p>
               
                    <!-- <div class="list-title  list-space"><img class="img-value"
                        src="../../../assets/images/list-arrow.svg" alt="image">
                    <p class="para">

                    </p>
                </div> -->

                <!-- <div class="list-title  list-space"><img class="img-value"
                    src="../../../assets/images/list-arrow.svg" alt="image">
                <p class="para">

                </p>
            </div> -->
            <!-- <div class="list-title  list-space"><img class="img-value"
                src="../../../assets/images/list-arrow.svg" alt="image">
            <p class="para">

            </p>
        </div> -->
               
                </div>
            </div>
        </div>
    </div>
    <div class="full-area-bg">
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="case-details-single">
                        <div class="area">
                            <h4> Challenge 
                            </h4>
                            <p class="para text-design">
                           
                                There were many challenges faced by the client while developing the website. The main challenge faced by the client is to develop a Payment Gateway with almost every promising payment method. This is mainly to focus on the users' point of view where they can easily make a purchase by using the website.                              
                            
                            </p>
                            <p class="para text-design">
                                The other challenge faced by the client is that the website has to be interactive, engaging, and user-centric.                             </p>
                          <!-- <P class="para text-design">
                            Love Bonito’s goal was that their website should be modified by implementing new features as per the ongoing trends. This is to ensure that customers would have an admirable shopping experience. Therefore, Love Bonito wanted an impeccable team of developers who provides superlative maintenance support also who can recommend strategies to boost online revenue and improve conversions.
                          </P>
                          <p class="para text-design">
                            The other main challenges that the client faced were:
                          </p> -->
                            <!-- <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">
                                    Their main concern was that the user information must be confidential, and there must be no security break via any method.

                                </p>
                            </div>
                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">


                                    The reflection of the amount might differ in the cart and at the time of checkout. This issue has to be resolved as the amount has to be reflected in similarities in both cases. 

                                </p>
                            </div>
                            <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para">

                                    In some cases, the promo code does not work for the users, resulting in losing potential customers at that time.

                                </p>
                            </div>
                            <div class="list-title  list-space"><img class="img-value"
                                src="../../../assets/images/list-arrow.svg" alt="image">
                            <p class="para">
                                The payment-related issues might be there so it was also the main concern that the client had.
                               

                            </p>
                        </div> -->

                        </div>

                    </div>
                </div>
                <div class="col-md-4">
                    <img src="../../../assets/images/girl.svg.svg" alt="Girl Building">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="case-details-single">
                    <div class="area">
                        <h4> Solution</h4>
                        <p class="para">Here is the team of Vidhema Technologies web engineers who come to the rescue as they have worked rigorously to complete the project. The team has created the website from scratch which is unique including all the required features and implementations. </p>
                       <P class="para">
                        Marc Fisher is an e-commerce company where web engineers have to implement the features according to the online platform. Here the team took the responsibility to implement the required features according to the ongoing trends                       </P>
                       <!-- <p class="para">
                        The website was in Magento, we re-developed it in a “Headless” form that the front end is in the Vue and backend is in Magento and afterward coupled both ends. Hence, it is now less complicated for the developers to modify it from the front and back ends. The frontend team and backend team can do changes as per their own requirements.
                       </p> -->
                        <div class="solution-box">
                            <div class="col-12 para-text">
                                

                                <p>
                                    To make purchasing easy for customers, the team has integrated the following payment gateways into the website:
                                </p>

                                <div class="row">
                                    <div class="col-md-8">
                              
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para new-para">

                                        UPI Payment                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para new-para">

                                        Amazon                                    </p>
                                </div>
                                <div class="list-title  list-space"><img class="img-value"
                                        src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para new-para">


                                        Google Pay                                     </p>
                                </div>

                                <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                <p class="para new-para">


                                    VISA                                  </p>
                                 </div>

                                 <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para new-para">
                                         Shop Pay                                 
                                    </p>
                                 </div>

                                 <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para new-para">
                                        American Express                                
                                    </p>
                                 </div>

                                 <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para new-para">
                                        Apple Pay                               
                                    </p>
                                 </div>

                                 <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para new-para">
                                        Discover                              
                                    </p>
                                 </div>


                                 
                                 <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para new-para">
                                        Meta Pay                           
                                    </p>
                                 </div>

                                 <div class="list-title  list-space"><img class="img-value"
                                    src="../../../assets/images/list-arrow.svg" alt="image">
                                    <p class="para new-para">
                                        Mastercard                          
                                    </p>
                                 </div>
                                
                                    </div>



                                    <div class="col-md-4">
                                        <img class="payment-img" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/fisher%20payment.png?alt=media&token=236e7de0-21d5-4875-8ee8-ac2f2e6d2bec">
                                    </div>
                                    
                                 </div>


                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 case-details-single">
                <div class="area">
                    <h4> Results</h4>

                    <p class="para">
                        The engagement on the website gradually increased and users spent time on the website making purchases. There was a smooth payment process for the users as they can use any of the methods that are feasible for them.
                    </p>

                    <p class="para">
                        The website created by the team of developers was according to the targeted audience as well as with all the required features. The website has all the categories which are necessary according to the footwear and style. The client faced huge growth in their business with its website. 
                    </p>


                    <!-- <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">

                            After the implementation, the website grew its traffic tremendously not only in Asian countries but also in countries such as the USA and Canada..
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">

                            As we pushed the website, it turns out that users are more putting their time into scrolling the website than before. It has a good user experience.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            Brand loyalty has increased among users as users and potential customers are repeating their orders and purchasing from Love Bonito’s website more often.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">

                            Love Bonito’s website is driving huge traffic on their website and they are expanding their stores in the global market.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            As per the stats and results, it is growing more rapidly than usual.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            It is less time-consuming than before.

                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            New features upgradation as per the latest trends.
                        </p>
                    </div>
                    <div class="list-title  list-space"><img class="img-value"
                            src="../../../assets/images/list-arrow.svg" alt="image">
                        <p class="para">


                            The Love Bonito website started loading faster.
                        </p>
                    </div> -->
                
                </div>
            </div>
        </div>
    </div>
    <section class="quote-box" style="    background-color: #0d052a;">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <h4>Are You Ready To Discuss Your Project With Us?</h4>
                </div>
                <div class="col-md-3">
                    <button routerLink="/hire-ionic-developers.html">Hire Our Experts</button>
                </div>
            </div>
        </div>
    </section>
    <div class="container">
        <div class="row gy-5">
            <div class="col-lg-12">
                <div class="case-details-single">

                    <!-- <p>Also, the ill person can share their point of story on this platform where that person can publish it on their own or can make someone close a nominee and that person can publish it after sometime. </p>
                    <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                        <p>
                         The main concern of the client was that the deployed product does not look like any other social media platform. Therefore, a very close look at the UI phase and the development phase was kept to achieve this difference in experience.
                        </p>
                             </div>
                             <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                                <p>
                                    More than writing memorials and tributes, the app had features such as SOS alerts, notifying people in case of emergency, asset management, critical alerts, posting, and commenting which were a custom build.
                                </p>
                                     </div>
                           
                                     <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                                        <p>
                                            The user experience and user interface needed to take care of from both ends making it user-friendly for the users as it was mostly used by old age people. 
                                        </p>
                                             </div> -->
                    <!-- <div class="container"> -->



                    <!-- </div> -->
                    <div class="area">
                        <h4>Technologies and Tools </h4>
                        <ul class="process-list half-description tech-des">
                            <li>
                                <div class="list-title  list-space"><img
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Shopify_logo1.svg?alt=media&token=a2358642-4c73-4616-8cb1-9397ade7ed0b" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>Angular</h5> -->
                                </div>
                            </li>
                            <!-- <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/ionic-icon.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>Ionic</h5> 
                                </div>
                            </li> -->
                            <!-- <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/nodejs.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>Node JS</h5>
                                </div>
                            </li> -->
                            <!-- <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/MySQL_textlogo.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>MySQL</h5> 
                                </div>
                            </li> -->
                            <!-- <li>
                                <div class="list-title  list-space"><img
                                        src="../../../assets/images/MongoDB_Logo.svg" alt="image"
                                        class="tech-logo">
                                    <!-- <h5>MongoDB  </h5> 
                                </div>
                            </li> -->
                        </ul>
                    </div>



<!-- <div class="container">
<div class="row">



<div class="area">
</div>
    <h4>Website Features</h4>
    <ul class="process-list half-description">
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <p class="para">Reward Points: We built a feature of loyalty and reward points where customers can receive loyalty points at the time of their purchase or after placing an order.
                </p>
            </div>
            
        </li>
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <p class="para">Birthday Discount: When customers have birthdays, they can get special discounts when they make a purchase from the website.
                </p>
            </div>
           
        </li>
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <p class="para">Tier Upgradation: There are medals for the users and customers tier-wise. They can up their tier level by becoming the most loyal customer. Users get medals like bronze, silver, and gold.
                </p>
            </div>
         
        </li>
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <p class="para">Emails: Users and customers get discounted offers via email where they can open a link and copy the code directly from their registered email IDs. 
                </p>
            </div>
            
        </li>
        <li>
            <div class="list-title"><img src="../../../assets/images/list-arrow.svg" alt="image">
                <p class="para">Country-Wise Currency Purchase: Customers can use their own country’s currency while making purchases.
                </p>
            </div>
           
        </li>
   
    </ul>
</div>
</div> -->







                
                  
                </div>
            </div>
        </div>
    </div>
</div>